export enum PopupActionResult {
    OK = 1,
    Cancel = 2,
}
